// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/common/close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/common/apply.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/common/plus_icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

tbody tr:hover .sticky {
  background-color: rgb(248 249 250 / var(--tw-bg-opacity));
  z-index: 2;
}

/* tbody tr td{
  height: 52px;
} */
tbody tr:hover td {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}

.css-t3ipsp-control {
  background-color: #EDF5FF !important;
}

.sales-form .react-select {
  width: 100%;
}

.sortfeature div.relative {
  width: 100%;
}
.select__indicator.select__clear-indicator {
  font-size: 12px;
  line-height: 14px;
  --tw-text-opacity: 1;
  color: rgb(0 36 102 / var(--tw-text-opacity, 1));
}
.select__indicator.select__clear-indicator svg {
  height: 16px;
  width: 16px;
}
@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* SEARCH ICON UPDATED */
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  height: 16px;
  width: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: contain;
}

input[type="search"]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}

input[type="radio"] {
  accent-color: #002466;
}

.customeDatepicker-change .react-datepicker-popper {
  left: -50px !important
}

.gropuBtnHover {
  display: none
}

.gropuBtn:hover .gropuBtnHover {
  display: flex;
}


@media print {
  div {
    overflow: visible !important;
    width: 100% !important;
    word-wrap: break-all !important;
    white-space: normal !important;
  }

  table {
    width: 100% !important;
    border-collapse: collapse !important;
  }

  th,
  td {
    word-wrap: break-all !important;
    white-space: normal !important;
  }

  body {
    margin: 0;
    padding: 0;
    width: 100% !important;
  }

  .print-container {
    overflow: visible !important;
    width: 100% !important;
  }

  .header_section,
  .footer_section,
  .no-print {
    display: none;
  }
}

/* this is using only for OrderMinMax dropdown  */
.paddingLeft .select__control {
  padding-left: 12px;
}
.pagination-dropdown .select__value-container {
  padding-top: 0px;
  padding-bottom: 0px;
}
.pagination-dropdown .select__control {
  min-height: 36px !important;
}
.pagination-dropdown .select__input-container, .pagination-dropdown .select__indicator {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
} 

.react-datepicker__input-container .react-datepicker__close-icon::after {
  background-color: transparent;
  font-size: 18px;
  line-height: 24px;
  --tw-text-opacity: 1;
  color: rgb(0 36 102 / var(--tw-text-opacity, 1));
}
.react-datepicker__input-container .react-datepicker__close-icon {
  top: 3px;
  right: 25px;
}

.customCheckbox:after {
  width: 29px;
  height: 32px;
  transform: translateX(0);
  top: -4px;
  left: -4px;
}

.customCheckboxBefore:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
}

.customCheckboxAfter:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
}


/* Table container */
.product-Cataloge-table .custome-scroll {
  position: relative;
}
/* Custom Table */
.product-Cataloge-table table {
  width: 100%;
}
/* Sticky Header */
.product-Cataloge-table thead {
  position: sticky;
  top: 0;
  z-index: 9;
}
@media print{
  .noprint{
      display:none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yDAAyD;EACzD,UAAU;AACZ;;AAEA;;GAEG;AAED;EAAA,kBAAqB;EAArB;AAAqB;;AAGvB;EACE,oCAAoC;AACtC;;AAGE;EAAA;AAAY;;AAIZ;EAAA;AAAY;AAGZ;EAAA,eAA6B;EAA7B,iBAA6B;EAA7B,oBAA6B;EAA7B;AAA6B;AAG7B;EAAA,YAAa;EAAb;AAAa;AAEf;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,6DAAoD;EACpD,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,oCAAoC;EACtC;;EAEA;;IAEE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;AACpB;AAEE;EAAA,gBAAU;EAAV;AAAU;AAGV;EAAA;AAAmB;AAGnB;EAAA,eAAe;EAAf,kBAAe;EAAf,gBAAe;EAAf;AAAe;;AAId;EAAA,6BAA4C;EAA5C,eAA4C;EAA5C,iBAA4C;EAA5C,oBAA4C;EAA5C;AAA4C;AAG7C;EAAA,QAA4B;EAA5B;AAA4B;;AAG9B;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,6DAAoD;AACtD;;AAEA;EACE,6DAAwD;AAC1D;;;AAGA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;AACA,iBAAiB;AACjB;EACE,WAAW;AACb;AACA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA;EACE;MACI,YAAY;EAChB;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\ntbody tr:hover .sticky {\n  background-color: rgb(248 249 250 / var(--tw-bg-opacity));\n  z-index: 2;\n}\n\n/* tbody tr td{\n  height: 52px;\n} */\ntbody tr:hover td {\n  @apply bg-lighestgray;\n}\n\n.css-t3ipsp-control {\n  background-color: #EDF5FF !important;\n}\n\n.sales-form .react-select {\n  @apply w-full\n}\n\n.sortfeature div.relative {\n  @apply w-full\n}\n.select__indicator.select__clear-indicator{\n  @apply text-primary-50 text-xs\n}\n.select__indicator.select__clear-indicator svg{\n  @apply w-4 h-4\n}\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* SEARCH ICON UPDATED */\ninput[type=\"search\"]::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n  height: 16px;\n  width: 16px;\n  background: url(./assets/common/close.svg) no-repeat;\n  background-size: contain;\n}\n\ninput[type=\"search\"]::-ms-clear {\n  display: none;\n  width: 0;\n  height: 0;\n}\n\ninput[type=\"radio\"] {\n  accent-color: #002466;\n}\n\n.customeDatepicker-change .react-datepicker-popper {\n  left: -50px !important\n}\n\n.gropuBtnHover {\n  display: none\n}\n\n.gropuBtn:hover .gropuBtnHover {\n  display: flex;\n}\n\n\n@media print {\n  div {\n    overflow: visible !important;\n    width: 100% !important;\n    word-wrap: break-all !important;\n    white-space: normal !important;\n  }\n\n  table {\n    width: 100% !important;\n    border-collapse: collapse !important;\n  }\n\n  th,\n  td {\n    word-wrap: break-all !important;\n    white-space: normal !important;\n  }\n\n  body {\n    margin: 0;\n    padding: 0;\n    width: 100% !important;\n  }\n\n  .print-container {\n    overflow: visible !important;\n    width: 100% !important;\n  }\n\n  .header_section,\n  .footer_section,\n  .no-print {\n    display: none;\n  }\n}\n\n/* this is using only for OrderMinMax dropdown  */\n.paddingLeft .select__control {\n  padding-left: 12px;\n}\n.pagination-dropdown .select__value-container{\n  @apply py-0\n}\n.pagination-dropdown .select__control{\n  @apply !min-h-[36px]\n}\n.pagination-dropdown .select__input-container, .pagination-dropdown .select__indicator{\n  @apply py-0 my-0\n} \n\n.react-datepicker__input-container .react-datepicker__close-icon::after{\n   @apply bg-transparent text-primary-50 text-md\n}\n.react-datepicker__input-container .react-datepicker__close-icon{\n  @apply top-[3px] right-[25px]\n}\n\n.customCheckbox:after {\n  width: 29px;\n  height: 32px;\n  transform: translateX(0);\n  top: -4px;\n  left: -4px;\n}\n\n.customCheckboxBefore:after {\n  background: url(./assets/common/apply.svg) no-repeat;\n}\n\n.customCheckboxAfter:after {\n  background: url(./assets/common/plus_icon.svg) no-repeat;\n}\n\n\n/* Table container */\n.product-Cataloge-table .custome-scroll {\n  position: relative;\n}\n/* Custom Table */\n.product-Cataloge-table table {\n  width: 100%;\n}\n/* Sticky Header */\n.product-Cataloge-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 9;\n}\n@media print{\n  .noprint{\n      display:none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
